import request from "../utils/request";

export const getDealerQuotas = '/sample/dealer/quota/';

export function getDealerQuotasDetail(dealerId: string) {
    return request.get('/sample/dealer/quota/', {params: {dealerId}});
}

export const getTradeRecords = '/sample/dealer/quota/trade/record';

export function addTradeRecord(params: any) {
    return request.post('/sample/dealer/quota/trade/record', params);
}

export function getDealerQuotaByDealer(dealerId:any) {
    return request.get('/sample/dealer/quota/byDealer', {params: {dealerId}});
};
